var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_24798)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 76C48.0782 76 57.7437 71.9964 64.8701 64.8701C71.9964 57.7437 76 48.0782 76 38C76 27.9218 71.9964 18.2563 64.8701 11.1299C57.7437 4.00356 48.0782 0 38 0C27.9218 0 18.2563 4.00356 11.1299 11.1299C4.00356 18.2563 0 27.9218 0 38C0 48.0782 4.00356 57.7437 11.1299 64.8701C18.2563 71.9964 27.9218 76 38 76ZM19 31.6667C17.3203 31.6667 15.7094 32.3339 14.5217 33.5217C13.3339 34.7094 12.6667 36.3203 12.6667 38C12.6667 39.6797 13.3339 41.2906 14.5217 42.4783C15.7094 43.6661 17.3203 44.3333 19 44.3333H57C58.6797 44.3333 60.2906 43.6661 61.4783 42.4783C62.6661 41.2906 63.3333 39.6797 63.3333 38C63.3333 36.3203 62.6661 34.7094 61.4783 33.5217C60.2906 32.3339 58.6797 31.6667 57 31.6667H19Z",
    fill: "#EB5757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_24798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusFailed);
export default __webpack_public_path__ + "static/media/status-failed.1e30c9e41044729d729a0cfee92b6588.svg";
export { ForwardRef as ReactComponent };